<template>
    <div class="ticket_printing">
        <p class="title">小票底部附加信息</p>
        <div class="contant">
            <div>
                <p class="left">附加文字</p>
                <p class="center" :style="text ? 'color:#333' : ''">{{text || '无'}}</p>
                <div class="right">
                    <button class="text-btn" @click="editText">修改</button>
                </div>
            </div>
            <div>
                <p class="left">附加图片</p>
                <i v-if="img" class="iconfont icondelete" @click="deteleImg"></i>
                <el-image
                    v-if="img"
                    fit="cover"
                    class="center show-img"
                    style="width: 40px; height: 40px"
                    :src="getQiniuImgUrl(img)"
                    :preview-src-list="[getQiniuImgUrl(img)]">
                </el-image>
                <p v-else class="center">无</p>
                <qiniu-upload
                    v-if="canUploadTicketImg"
                    slot="btn"
                    class="right"
                    :useDefault="false"
                    @upload-success="uploadSuccess">
                    <button class="text-btn">{{img ? '修改' : '添加'}}</button>
                </qiniu-upload>
                <div v-else class="right">
                    <button class=" text-btn" @click="tipUpVersion">{{img ? '修改' : '添加'}}</button>
                </div>
            </div>
        </div>
        <AdditionalText 
            headerTitle="小票底部附加文字"
            :showDialog="showDialog"
            @confirm="dialogConfim"
            @close="dialogClose"
            @opened="$refs.textareaRef.focus()"
            :canUse="true">
                <el-input
                ref="textareaRef"
                type="textarea"
                placeholder="请输入小票底部附加文字"
                maxlength="50"
                show-word-limit
                style="height:100px"
                resize="none"
                @input="inputSpaceLimit($data, 'iptValue')"
                v-model="iptValue"
                 />
                <p class="error-title" v-if="iptValue.length === 50">内容已满50个字</p>
        </AdditionalText>
    </div>
</template>

<script>
// utils
import { createComponent, ref, onBeforeMount } from '@vue/composition-api'
import $fetch from '@/api'
import { inputLimit, inputSpaceLimit, inputValider } from "@/utils/index.ts"
import { openMessage } from '@/utils/system.tsx'
import { getQiniuImgUrl } from '@/assets/ts/qiniu'
import { editionJudge } from '@/utils/editionJudge'
// components
import AdditionalText from '../shop_info/modules/update_dialog'
import QiniuUpload from '@/components/qiniu_upload/qiniu_upload.vue'

export default createComponent({
    setup(props, ctx) {
        const text = ref('')
        const img = ref('')
        const showDialog = ref(false)
        const iptValue = ref('')

        function uploadSuccess({key}) {
            $fetch.post({
                url: '/shop/updatereceiptprintconfig',
                params: {
                    attach_img_url: key
                }
            }).then(() => {
                img.value = key
                openMessage("success", "更新成功")
            }).catch(e => {
                openMessage("error", e.message || "更新失败")
            })
        }

        function editText() {
            showDialog.value = true
        }

        function tipUpVersion() {
            openMessage("error", "升级到专业/旗舰版，可使用附件图片功能")
        }

        function dialogConfim(cb) {
            const val = iptValue.value.replace(/[\n\r]/g, '')
            $fetch.post({
                url: '/shop/updatereceiptprintconfig',
                params: {
                    attach_text: val
                }
            }).then(() => {
                openMessage("success", "更新成功")
                text.value = iptValue.value = val
                showDialog.value = false
            }, e => {
                openMessage("error", e.message || "更新失败")

            }).then(() => cb())
        }

        function dialogClose() {
            showDialog.value = false
            iptValue.value = text.value
        }

        function getTickInfo() {
            $fetch.post({
                url: '/shop/getreceiptprintconfig'
            }).then(res => {
                text.value = res.attach_text
                iptValue.value = res.attach_text
                img.value = res.attach_img_url
            }).catch(e => {
                openMessage("error", e.message || "获取数据失败")
            })
        }
        
        function deteleImg() {
            uploadSuccess({
                key: ''
            })
        }

        onBeforeMount(() => {
            getTickInfo()
        })

        return {
            text,
            img,
            showDialog,
            iptValue,
            canUploadTicketImg: !editionJudge.isBiaoZhun,
            // methods
            uploadSuccess,
            dialogConfim,
            dialogClose,
            inputSpaceLimit,
            getQiniuImgUrl,
            deteleImg,
            editText,
            tipUpVersion
        }
    },

    components: {
        AdditionalText,
        QiniuUpload
    }
})
</script>

<style lang="scss" scoped>
::v-deep .el-textarea{
    margin-bottom: 10px;
    
    .el-textarea__inner {
        height: 100px;
        padding: 10px 8px;
    }
    .el-input__count {
        line-height: 20px;
        padding: 0;
        font-size: 14px;
        color: #999;
        right: 8px;
        bottom: 4px;
    }
}
.ticket_printing {
    font-size: 14px;
    color: #999;
    line-height: 45px;

    .title {
        position: relative;
        line-height: 20px;
        margin: 20px 0 12px;
        padding-left: 8px;
        font-weight: 600;
        color: #333;

        &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            width: 4px;
            height: 20px;
            background-color: #009688;
            border-radius: 2px;
        }
    }

    .contant {
        padding: 0 5px 0 12px;
        border: 1px solid #ebebeb;

        > div {
            position: relative;
            display: flex;
            height: 50%;

            .left {
                width: 130px;
            }

            .center p{
                flex: 1;
            }

            .right {
                flex: 1;
                text-align: right;
            }

            .icondelete {
                position: absolute;
                top: -4px;
                left: 161px;
                font-size: 16px;
                line-height: 16px;
                color: #333;
                z-index: 2
            }

            .show-img {
                position: relative;
                top: 2px;
                width: 40px;
                height: 40px;
                border: 1px solid #DDD;
                border-radius: 4px;
            }
        }
    }
}

.error-title {
    position: absolute;
    top: 122px;
    left: 12px;
    font-size: 12px;
    color: #FF6565;
    line-height: 18px;
}
</style>